import { styled } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import COLORS from '../../styles/theme/colors';

export const TableFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'sticky',
  bottom: '0',
  padding: 10,
  zIndex: 10,
  background: 'white'
}));

export const FormRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10,

  '&>div': {
    flex: 1,
    maxWidth: '50%'
  }
}));

export const TableLabel = styled('div')({
  cursor: 'pointer',
  transition: '0.3s',
  position:  'relative',
  textOverflow: 'ellipsis',
  width: 'inherit',
  whiteSpace: 'nowrap',
  overflow: 'hidden',

  '&.error': {
    color: COLORS.red
  },

  '&:hover': {
    color: COLORS.accent,

    '&.error': {
      color: COLORS.red
    }
  }
});

export const FormItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),

  '& .MuiInputLabel-root': {
    fontSize: 12,
    color: COLORS.textSecondColor,
    marginBottom: theme.spacing(0.5),
    borderRadius: 8
  },

  '& .MuiSelect-select': {
    padding: '11.5px 16px',
    borderRadius: 8
  },

  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    borderRadius: 8,
    color: COLORS.textSecondColor,

    '& input': {
      borderRadius: 8,
      color: COLORS.textSecondColor,
      padding: theme.spacing(1.3, 2),
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1
      }
    }
  }
}));

export const PopoverWrap = styled(Popover)({
  '& .MuiPaper-root': {
    borderRadius: '14px',
  },
  '& .MuiModal-backdrop': {
    backgroundColor: 'transparent !important'
  }
});

export const HintWrap = styled('div')({
  borderRadius: '14px',
  maxWidth: 430
});

export const HintRow = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: '0 20px'
});

export const HintItem = styled('div')({
  flex: 1,
  minWidth: '150px',
  padding: '8px 15px',

  '& .label': {
    margin: '0 0 0px',
    color: '#778097'
  }
});

export const HintHeader = styled('div')({
  background: '#FCFDFD',
  border: '0.6px solid #D5D5D5',
  borderRadius: '14px 14px 0px 0px',
  padding: 15,
  fontWeight: 600,
  fontSize: '20px'
});

export const InfoWrap = styled('div')({
  width: '17px',
  height: '17px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
